// Mock data for Stadium Plaza Center Retail Project

export const projectInfo = {
  name: "Stadium Plaza Center",
  tagline: "Georgetown's Premier Multi-Tenant Retail Destination",
  address: "510 Stadium Drive",
  city: "Georgetown",
  state: "TX",
  zip: "78628",
  description: "A thoughtfully designed, ground-up commercial development transforming an underutilized site into a vibrant commercial hub that caters to commuters, stadium visitors, and the rapidly growing residential population.",
  heroImage: "https://customer-assets.emergentagent.com/job_02cd2a42-5122-48f5-b136-c67f1a99c678/artifacts/7sc81kgx_strpMall.png"
};

export const projectHighlights = [
  {
    id: 1,
    title: "Prime Location",
    description: "Strategically positioned at the intersection of Stadium Drive and Inner Loop with exceptional visibility and accessibility.",
    icon: "MapPin"
  },
  {
    id: 2,
    title: "Modern Architecture",
    description: "Contemporary two-story design with flexible tenant configurations and pedestrian-friendly layout.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Ample Parking",
    description: "Optimized parking configurations with clearly designated stalls and efficient traffic flow patterns.",
    icon: "Car"
  },
  {
    id: 4,
    title: "High Traffic Area",
    description: "Captures peak visitation during stadium events while maintaining sustainable daily customer traffic.",
    icon: "Users"
  },
  {
    id: 5,
    title: "Community Focus",
    description: "Designed to serve the rapidly growing residential population and become a long-term economic anchor.",
    icon: "Heart"
  },
  {
    id: 6,
    title: "ADA Compliant",
    description: "Full accessibility compliance with designated routes and amenities for all visitors.",
    icon: "Accessibility"
  }
];

export const tenantMix = [
  {
    id: 1,
    category: "Food & Beverage",
    description: "Curated dining concepts from casual eateries to specialty coffee shops",
    icon: "UtensilsCrossed"
  },
  {
    id: 2,
    category: "Service-Based",
    description: "Professional services, salons, and convenience-oriented businesses",
    icon: "Briefcase"
  },
  {
    id: 3,
    category: "Wellness & Fitness",
    description: "Health-focused offerings including fitness studios and wellness centers",
    icon: "Dumbbell"
  },
  {
    id: 4,
    category: "Daily Needs Retail",
    description: "Essential retailers serving everyday community requirements",
    icon: "ShoppingBag"
  }
];

export const projectSpecs = [
  { label: "Total Site Area", value: "±1.5 Acres" },
  { label: "Total Building SF", value: "13,603 SF" },
  { label: "1st Floor", value: "1,178 - 4,940 SF" },
  { label: "2nd Floor", value: "1,178 - 4,200 SF" },
  { label: "Parking Spaces", value: "50+ Stalls" },
  { label: "Completion", value: "Q4 2027" }
];

export const locationFeatures = [
  "Near the new Costco in Georgetown",
  "Direct access from Stadium Drive",
  "Inner Loop visibility and access",
  "Near rapidly expanding residential areas",
  "Strong connectivity to downtown Georgetown",
  "Minutes from I-35 corridor"
];

export const contactInfo = {
  phone: "(512) 555-0123",
  email: "leasing@stadiumplazacenter.com",
  brokerName: "Commercial Realty Partners",
  hours: "Mon-Fri: 9AM - 6PM"
};
